import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushContenus } from '@components/push-contenus/models';
import { ButtonComponent } from '@shared/components/button';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-contenus',
  imports: [TitleComponent, OptionCardComponent, SvgComponent, ButtonComponent, RouterLink],
  templateUrl: './push-contenus.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushContenusComponent extends AbstractDynamicComponent<PushContenus> {}
